import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

const TrueFalse = ({ check }: { check: boolean }) => (check ? (<CheckCircleIcon color='success' />) : (<CancelIcon color='error' />));

export default TrueFalse;
